import {RouteLocationNormalized, RouterView} from "vue-router";
import {IBreadcrumbMeta} from "cdp-fe-commons-layout";

const Istanze = () => import('@/views/istanze/Istanze.vue')
const IstanzeAdmin = () => import('@/views/istanze/InstanzeAdmin.vue')
const OnlineRequestForm = () => import('@/views/istanze/OnlineRequestForm.vue')
const ArchivioIstanze = () => import('@/views/istanze/ArchivioIstanze.vue')
/*const Lavagna = () => import('@/views/istanze/Lavagna.vue')*/

const istanzeRoutes = [
    {
        path: 'procedimento',
        name: 'I tuoi Procedimenti',
        component: RouterView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'ProcedimentiAttivi',
                component: Istanze,
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            {
                path: 'richiestaonline/:codiceIstanza',
                name: "Compila richiesta da procedimento",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customName: "Compila Online"
                    } as IBreadcrumbMeta
                },
                component: OnlineRequestForm,
            },
           /* {
                path: 'lavagna/:codiceIstanza',
                name: "Lavagna Richiesta",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customName: "Lavagna"
                    } as IBreadcrumbMeta
                },
                component: Lavagna,
            }*/
        ]
    },
    {
        path: 'procedimentoAdmin',
        name: 'Tutti Procedimenti',
        component: RouterView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'Tutti ProcedimentiAttivi',
                component: IstanzeAdmin,
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            /* {
                 path: 'lavagna/:codiceIstanza',
                 name: "Lavagna Richiesta",
                 meta: {
                     requiresAuth: true,
                     breadcrumb: {
                         customName: "Lavagna"
                     } as IBreadcrumbMeta
                 },
                 component: Lavagna,
             }*/
        ]
    },
    {
        path: 'archivio',
        name: 'Archivio Procedimenti',
        component: RouterView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'ArchivioDelleIstanze',
                component: ArchivioIstanze,
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            {
                path: ':codiceIstanza',
                name: "Procedimento Archiviato",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customNameBeforeResolve: (to: RouteLocationNormalized) => {
                            return Promise.resolve(to.params.codiceIstanza as string ?? 'Istanza');
                        },
                    } as IBreadcrumbMeta,
                },
                /*component: Lavagna,*/
            }
        ]
    },
];

export default istanzeRoutes;
